import React from "react";

import { theme } from "../constants";

export const ProductPrice = ({ containerStyle, item }) => {
  // Check if item_disc_price exists and is not null or empty
  const hasDiscount = item['item_dis_price'] != null && item['item_dis_price'] !== "";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
        ...containerStyle,
      }}
    >
      {hasDiscount ? (
        <>
        <span
            style={{
              fontSize: 14,
              ...theme.fonts.Mulish_600SemiBold,
              color: theme.colors.mainColor,
            }}
          >
            {item['item_dis_price']}
          </span>
          {/* Slashed Original Price with Red Line */}
          <span
            style={{
              fontSize: 12,
              ...theme.fonts.Mulish_600SemiBold,
              color: theme.colors.mainColor,
              textDecoration: "line-through",
              textDecorationColor: "red",
            }}
          >
            {item.item_price}
          </span>

          {/* Discounted Price */}
          
        </>
      ) : (
        /* Regular Price when no discount is available */
        <span
          style={{
            fontSize: item?.oldPrice ? 14 : 12,
            ...theme.fonts.Mulish_600SemiBold,
            color: theme.colors.mainColor,
          }}
        >
          {item?.item_price}
        </span>
      )}
    </div>
  );
};